import { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

class Await extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
    this._is_mounted = true;
  }

  componentDidMount() {
    if (this.props.time) {
      setTimeout(() => {
        if (this._is_mounted) {
          this.setState({ loading: false });
        }
      }, this.props.time);
    }
  }

  componentWillUnmount() {
    this._is_mounted = false;
  }

  render() {
    let { children } = this.props;
    let classes;

    if (this.props.time) {
      classes = clsx('await-loading', {
        'await-done': !this.state.loading,
      });
    } else {
      classes = clsx('await-loading', {
        'await-done': !this.props.loading,
      });
    }

    return <div className={classes}>{children}</div>;
  }
}

Await.propTypes = {
  loading: PropTypes.bool,
  time: PropTypes.number,
};

export default Await;
